import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { AISummary } from '../../types/gig/interfaces';

const DISABLED_COUNTRIES = ['AU', 'GB'];

export const isAISummaryPhaseOne = (params: { locale: string; countryCode: string; aiSummary: AISummary }) => {
    const { locale, countryCode, aiSummary } = params;

    return locale === DEFAULT_FIVERR_LOCALE && !!aiSummary.csm_seller_gig && !DISABLED_COUNTRIES.includes(countryCode);
};
